import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleHalfFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCircleHalfFill"><Path fillRule="evenodd" clipRule="evenodd" d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5V3.5ZM2 12C2 6.47715 6.47715 2 12 2C12.2725 2 12.5427 2.01092 12.81 2.03237C17.9544 2.44515 22 6.74975 22 12C22 17.2502 17.9544 21.5548 12.81 21.9676C12.5427 21.9891 12.2725 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleHalfFill;
